import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import TreeSelect from "./components/TreeSelect";
import TreeSelectSettings from "./components/TreeSelectSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/tree_select_settings.svg";
import { getLocale, defaultTarget, selectCheckboxTreeDataSource } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'treeSelect',
    group: ElementGroup.COMPLEX,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_TREESELECT'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        autoInitialize: true,
        treeData: selectCheckboxTreeDataSource,
        treeCheckable: true,
        showSearch: true,
        treeDefaultExpandAll: true,
        allowClear: true,
        treeNodeFilterProp: 'title',
        url: {
          url: 'https://mock.iwhalecloud.com/mock/1889/api/selecttreedata'
        }
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_TREESELECT']
      },
      settings: {
        margin: {
          mobile: { all: 0 },
          desktop: { all: 0 },
          advanced: true
        },
        padding: {
          mobile: { all: 0 },
          desktop: { all: 0 },
          advanced: true
        },
        width: {
          value: "100%"
        },
        height: {
        },
      }
    },
    pluginComponent: TreeSelect, // 插件渲染组件
    pluginSettingComponent: TreeSelectSettings, // 插件设置项组件
  }
}
